import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import apiRequest from 'src/api/apiRequest';
import ApiEndpoint from 'src/api/endpoints';
import { AdminBundle } from 'src/api/optimalprint-sdk.d';
import ItemsListSearchInput from 'src/component/ItemsListSearchInput';
import PageContent from 'src/component/PageContent';
import { getUrl, RouteName } from 'src/routing';
import LandingPageCategoryListItem from 'src/view/LandingPageCategoryList/LandingPageCategoryListItem';

export interface OwnProps {
}

export interface Props extends OwnProps {

}

const LandingPageCategoryList = (props: Props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [searchInputValue, setSearchInputValue] = useState('');
  const [items, setItems] = useState(
    [] as AdminBundle.Entity.API.LandingPageCategoryControllerV1.LandingPageCategoryListV1Response.LandingPageCategory[],
  );

  const fetchData = async () => {
    try {
      const response = await apiRequest(
        ApiEndpoint.landingPageCategoryV1List,
        {},
        'data.items',
      ) as AdminBundle.Entity.API.LandingPageCategoryControllerV1.LandingPageCategoryListV1Response.LandingPageCategory[];
      setItems(response);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isLoading) {
      fetchData();
    }
  }, [isLoading]);

  const filteredItems = search
    ? items.filter((route) => ((route.name || '').toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1)) : items;

  return (
    <PageContent title="Landing page category list" isLoading={isLoading}>
      <ItemsListSearchInput onSearch={setSearch} onChange={setSearchInputValue} currentValue={searchInputValue} />
      <div className="row mb-3">
        <div className="col-12 text-right">
          <Link className="btn btn-success" to={getUrl(RouteName.landingPageCategoryAdd)}>Add new landing page</Link>
        </div>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Enabled</th>
            <th scope="col">Name</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredItems.map((r) => (<LandingPageCategoryListItem item={r} key={r.landingPageCategoryId} />))}
        </tbody>
      </table>
    </PageContent>
  );
};

export default LandingPageCategoryList;
